module.exports = __webpack_public_path__ + "img/thumb_image6.7b744f6b.jpg";